import { Injectable } from '@angular/core';
import { getHttpHeaders } from '@commons/utility/util';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { routes } from '@model/constants/routes';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Injectable({
  providedIn: 'root',
})
export class MissingFieldService {
  apiUrl = environment.apiGatewayUrl;
  private headers = getHttpHeaders();

  constructor(private http: HttpClient) {}

  public getMissingFields(): Observable<FormlyFieldConfig[]> {
    return this.http
      .get(this.apiUrl + routes.sanitizeFields, {
        headers: this.headers,
      })
      .pipe(
        map((response: FormlyFieldConfig[]) => {
          return response;
        })
      );
  }

  public sendFixedFields(request: any): Observable<any> {
    return this.http.post(this.apiUrl + routes.sanitizeFields, request, {
      headers: this.headers,
    });
  }
}
